import { gql } from '@apollo/client';

const addOnDefinitionFragment = gql`
  fragment AddOnDefinitionFragment on AddOnDefinition {
    id
    name
    slug
    monthlyRate
    annualRate
    trialDays
    active
  }
`;
export const updateVenuePlanMutation = gql`
  mutation UpdateVenuePlan($input: UpdateVenuePlanInput!) {
    updateVenuePlan(input: $input) {
      venue {
        id
        name
        subscription {
          id
          planDefinitionId
          planName
          tier
          billingInterval
          monthlyRate
          cardApplicationFeeRate
          achApplicationFeeRate
          stripeSourceId
        }
        addOnPlans {
          id
          status
          active
          endDate
          addOnDefinition {
            id
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const planDefinitionsQuery = gql`
  query VenueCustomerPlanDefinitions($venueId: ID) {
    venueCustomerPlanDefinitions(venueId: $venueId) {
      id
      tier
      planName
      billingInterval
      monthlyRate
      stripeProductId
      stripePriceId
      active
    }
  }
`;

export const createVenueMutation = gql`
  mutation CreateNewVenue($input: CreateVenueInput!) {
    createVenue(input: $input) {
      venue {
        id
        subscription {
          id
          planName
          planDefinitionId
          stripeSourceId
        }
      }
      errors {
        message
      }
    }
  }
`;

export const venueUpgradeDetailsQuery = gql`
  query VenueUpgradeDetails($id: ID!) {
    venue(id: $id) {
      id
      name
      subscription {
        id
        planDefinitionId
        planName
        tier
        billingInterval
        monthlyRate
        stripeSourceId
      }
      addOnPlans {
        id
        status
        active
        endDate
        addOnDefinition {
          id
          ...AddOnDefinitionFragment
        }
      }
    }
  }
  ${addOnDefinitionFragment}
`;

export const addOnDefinitionsQuery = gql`
  query AddOnDefinitions {
    addOnDefinitions {
      id
      ...AddOnDefinitionFragment
    }
  }
  ${addOnDefinitionFragment}
`;

export const organizationQuery = gql`
  query OrganizationUpgradeDetails($id: ID!) {
    organization(id: $id) {
      id
      billingEmail
      billingAddress {
        streetAddress1
        streetAddress2
        city
        state
        zip
        country
        formattedAddress
      }
      discount
      addOnDiscount
      venues {
        id
      }
      paymentMethods {
        id
        brand
        last4
        expMonth
        expYear
        paymentMethodType
        isDefault
      }
    }
  }
`;
